import React from 'react'
import InputField from 'components/molecules/input-field'
import PropTypes from 'prop-types'
import ProductSizeSelectField from 'domains/product-size/molecules/select-field'
import ProductAttributeDynamicFields from 'domains/product-attribute/organisms/dynamic-fields'

const propTypes = {
  parentName            : PropTypes.string.isRequired,
  fieldIndex            : PropTypes.number,
  productSizes          : PropTypes.array,
  disabledFields        : PropTypes.object,
  measurementAttributes : PropTypes.array
}

const defaultProps = {
  fieldIndex     : 0,
  isAlreadyLive  : false,
  disabledFields : {}
}

/**
 * Represent single variant field for Market Product
 * @param {string} parentName - Field array parent value
 * @param {number} fieldIndex - Field array index
 * @param {array} productSizes - Product Sizes options
 * @param {bool} disabledFields - consist of disabled fields
 * @param {array} measurementAttributes - Product Attributes with measurement context
 */
const SellerMarketProductSingleVariantField = ({
  fieldIndex,
  parentName,
  productSizes,
  disabledFields,
  measurementAttributes
}) => (
  <>
    {
      // * we only show sizes field if selected category has size opitons
      // * some categories does not have size attribute, e.i Tas, Makeup, aksesoris
      productSizes.length > 0
        ? (
          <ProductSizeSelectField
            name={ `${parentName}.${fieldIndex}.size` }
            label='Ukuran'
            required={ true }
            options={ productSizes }
            isDisabled={ disabledFields?.size }
          />
        )
        : null
    }

    <InputField
      name={ `${parentName}.${fieldIndex}.quantity` }
      label='Kuantitas'
      type='number'
      required={ true }
      disabled={ disabledFields?.quantity }
    />

    <ProductAttributeDynamicFields
      prefixName={ `${parentName}.${fieldIndex}` }
      attributes={ measurementAttributes }
    />
  </>
)

SellerMarketProductSingleVariantField.propTypes    = propTypes
SellerMarketProductSingleVariantField.defaultProps = defaultProps

export default SellerMarketProductSingleVariantField
